import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { addWeeks, weekRangeLabel } from "@/lib/week";

export default function WeekPicker({ week, setWeek, sub }) {
  return (
    <div className="flex items-center gap-1.5" data-testid="week-picker">
      <button
        data-testid="week-prev"
        onClick={() => setWeek(addWeeks(week, -1))}
        className="h-9 w-9 rounded-md border border-zinc-300 bg-white flex items-center justify-center hover:border-zinc-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600"
      >
        <ChevronLeft className="h-4 w-4 text-zinc-500" />
      </button>
      <div className="px-3 py-1 rounded-md bg-white border border-zinc-300 text-center min-w-[180px]">
        {/* R7: met een call-tekst is dié het hoofdlabel; de ISO-week + datums gaan naar de kleine regel. */}
        <div className={`${sub ? "font-heading" : "font-mono"} text-sm font-bold text-zinc-900 tracking-tight`} data-testid="week-label">{sub || week}</div>
        <div className="text-[11px] text-zinc-500" data-testid="week-sub">{sub ? `${week} · ${weekRangeLabel(week)}` : weekRangeLabel(week)}</div>
      </div>
      <button
        data-testid="week-next"
        onClick={() => setWeek(addWeeks(week, 1))}
        className="h-9 w-9 rounded-md border border-zinc-300 bg-white flex items-center justify-center hover:border-zinc-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600"
      >
        <ChevronRight className="h-4 w-4 text-zinc-500" />
      </button>
    </div>
  );
}

export function OmSelector({ om, setOm, oms, inactiveOms = [], selfUsername }) {
  const others = (oms || []).filter((o) => o !== selfUsername);
  return (
    <div className="flex items-center gap-1 rounded-md border border-zinc-300 bg-white p-0.5" data-testid="om-selector">
      {selfUsername && (
        <button
          key="__self"
          data-testid="om-select-self"
          onClick={() => setOm(selfUsername)}
          className={`px-3 py-1.5 rounded-sm text-sm font-semibold transition-colors ${
            om === selfUsername ? "bg-zinc-950 text-white" : "text-zinc-500 hover:bg-zinc-100"
          }`}
        >
          Mijn ritme
        </button>
      )}
      {others.map((o) => (
        <button
          key={o}
          data-testid={`om-select-${o}`}
          onClick={() => setOm(o)}
          className={`px-3 py-1.5 rounded-sm text-sm font-semibold capitalize transition-colors ${
            om === o ? "bg-zinc-950 text-white" : "text-zinc-500 hover:bg-zinc-100"
          }`}
        >
          {o}
        </button>
      ))}
      {inactiveOms.length > 0 && (
        <>
          <div className="mx-1 h-5 w-px bg-zinc-200" aria-hidden />
          <span className="text-[10px] font-semibold uppercase tracking-wider text-zinc-400 px-1">Uit dienst</span>
          {inactiveOms.map((o) => (
            <button
              key={o}
              data-testid={`om-select-${o}`}
              onClick={() => setOm(o)}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-sm text-sm font-semibold capitalize transition-colors ${
                om === o ? "bg-zinc-700 text-white" : "text-zinc-400 hover:bg-zinc-100"
              }`}
            >
              {o}
              <span className={`text-[9px] font-medium normal-case px-1 py-0.5 rounded-full ${om === o ? "bg-zinc-600 text-zinc-200" : "bg-zinc-100 text-zinc-400"}`}>uit dienst</span>
            </button>
          ))}
        </>
      )}
    </div>
  );
}
